module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#cricket",
      toString: function () {
        return this.url;
      }
    }